export const ALERT_DATA_SUCCESS = "alert-data-success";
export const ALERT_DATA_DESELECT = "alert-data-deselect";
export const ALERT_DATA_ERROR = "alert-data-error";

export const ALERT_UPDATE_TAB_ID = "alert-update-tab-id";
export const ALERT_UPDATE_TAB_NUM = "alert-update-tab-num";
export const ALERT_UPDATE_COMPOSE = "alert-update-compose";
export const ALERT_UPDATE_DATA_LIST = "alert-update-data-list";
export const ALERT_UPDATE_LIST = "alert-update-list";
export const ALERT_UPDATE_LIST_TYPE = "alert-update-list-type";
export const ALERT_UPDATE_LIST_ITEM_TYPE = "alert-update-list-item-type";
export const ALERT_UPDATE_LIST_ITEM = "alert-list-item";
export const ALERT_UPDATE_NODE = "alert-update-node";
export const ALERT_UPDATE_PREVIOUS_NODE = "alert-update-previous-node";
export const ALERT_SET_WARNING = "alert-set-warning";
export const ALERT_RESET_COMPOSE = "alert-reset-compose";
export const ALERT_TOGGLE_WARNING = "alert-toggle-warning";
export const ALERT_TOGGLE_UPDATE_ALERT = "alert-toggle-update-alert";
export const ALERT_MULTIMEDIA_STATE_CHANGE = "alert-multimedia-state-change";
export const ALERT_TOGGLE_COMPOSE = "alert-toggle-compose";
export const ALERT_TOGGLE_RIGHTPANEL = "alert-toggle-rightpanel";

export const ALERT_SEARCH_LIST_CHANGED = "alert-search-list-changed";
export const ALERT_TOGGLE_SEARCHBAR = "alert-toggle-searchbar";

export const ALERT_UPDATE_COMPOSE_DATA = "alert-update-compose-data";
export const ALERT_UPDATE_COMPOSE_BARS = "alert-update-compose-bars";



// WEBPACK FOOTER //
// ./src/actions/alerts/types.ts